export const values = {
  xxsmall: '5px',
  xsmall: '10px',
  small: '20px',
  base: '30px',
  large: '40px',
  xlarge: '60px',
}

export type SpacingNames = keyof typeof values
